import React, { useMemo } from "react";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";

const ToolSeoBenefits = ({
  eyebrow = "Why it matters",
  title,
  description,
  benefits = []
}) => {
  const { isDark } = useThemeMode();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  return (
    <section style={{ padding: "18px 20px 36px", background: colors.sectionBg }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "26px" }}>
          <div
            style={{
              display: "inline-flex",
              padding: "7px 12px",
              borderRadius: "999px",
              background: isDark ? "rgba(109,40,217,0.18)" : "#f5f3ff",
              color: isDark ? "#d8b4fe" : "#6d28d9",
              fontWeight: "700",
              fontSize: "12px",
              marginBottom: "14px",
              border: isDark ? `1px solid ${colors.border}` : "none"
            }}
          >
            {eyebrow}
          </div>

          <h2
            style={{
              margin: "0 0 12px",
              color: colors.text,
              fontSize: "clamp(2rem, 4vw, 3rem)",
              lineHeight: "1.08"
            }}
          >
            {title}
          </h2>

          <p
            style={{
              maxWidth: "760px",
              margin: "0 auto",
              color: colors.textMuted,
              fontSize: "16px",
              lineHeight: "1.7"
            }}
          >
            {description}
          </p>
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            gap: "18px"
          }}
        >
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              style={{
                background: colors.cardBg,
                border: `1px solid ${colors.border}`,
                borderRadius: "22px",
                padding: "22px",
                boxShadow: colors.shadow,
                backdropFilter: isDark ? "blur(14px)" : "none"
              }}
            >
              <div
                style={{
                  width: "42px",
                  height: "42px",
                  borderRadius: "12px",
                  background:
                    index % 2 === 0
                      ? "linear-gradient(135deg, #2563eb, #7c3aed)"
                      : "linear-gradient(135deg, #16a34a, #059669)",
                  marginBottom: "16px"
                }}
              />

              <h3
                style={{
                  margin: "0 0 10px",
                  color: colors.text,
                  fontSize: "20px",
                  lineHeight: "1.3"
                }}
              >
                {benefit.title}
              </h3>

              <p
                style={{
                  margin: 0,
                  color: colors.textMuted,
                  lineHeight: "1.7",
                  fontSize: "15px"
                }}
              >
                {benefit.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolSeoBenefits;